/**
 * Interface intended to be extended by other packages
 */
export interface ColorSchemeClasses {
    light: string;
    dark: string;
}

export type ColorScheme = keyof ColorSchemeClasses;

export const colorSchemeClasses: ColorSchemeClasses = {
    light: 'light',
    dark: 'dark',
};
